/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Willexpireprefix2Inputs */

const zh_subscription_willexpireprefix2 = /** @type {(inputs: Subscription_Willexpireprefix2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将于`)
};

const en_subscription_willexpireprefix2 = /** @type {(inputs: Subscription_Willexpireprefix2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expires on`)
};

const es_subscription_willexpireprefix2 = /** @type {(inputs: Subscription_Willexpireprefix2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expira el`)
};

/**
* | output |
* | --- |
* | "Expires on" |
*
* @param {Subscription_Willexpireprefix2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const subscription_willexpireprefix2 = /** @type {((inputs?: Subscription_Willexpireprefix2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Willexpireprefix2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_subscription_willexpireprefix2(inputs)
	if (locale === "en") return en_subscription_willexpireprefix2(inputs)
	return es_subscription_willexpireprefix2(inputs)
});
export { subscription_willexpireprefix2 as "subscription_willExpirePrefix" }